import { ColumnTable, Icon } from '@octano/global-ui';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';

import { Compatibility } from '../../../../types/courseMaintainerTypes';
import { CourseFormMode } from '../types';

export const useColumnsCompatibilities = ({
  mode,
  onDeleteCompatibility,
  readOnly = false,
}: {
  mode: CourseFormMode;
  onDeleteCompatibility: (index: number) => void;
  readOnly?: boolean;
}) => {
  const { t } = useTranslation(TranslationsKeys.ACADEMIC_OFFER_COURSES_UPDATE);

  const columns: ColumnTable<Compatibility>[] = useMemo(() => {
    const isDisabled = readOnly || mode === CourseFormMode.WATCH;
    return [
      {
        columnName: 'shortening',
        width: '30%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`compatibilityShortening`),
      },
      {
        columnName: 'name',
        width: '40%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`compatibilityName`),
      },
      {
        columnName: 'credits',
        width: '15%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`compatibilityCredits`),
      },
      {
        columnName: 'id',
        width: '15%',
        thClassName: 'text-center',
        tdClassName: 'text-center',
        headerText: t(`compatibilityDelete`),
        cellFormat: ({ index }) => (
          <div
            className={!isDisabled ? 'cursor-pointer' : ''}
            onClick={() => {
              if (!isDisabled) {
                onDeleteCompatibility(index);
              }
            }}
          >
            <Icon
              size="15"
              name="trash"
              color={isDisabled ? 'disabled' : 'primary'}
            />
          </div>
        ),
      },
    ];
  }, [t, onDeleteCompatibility, mode, readOnly]);

  return { columns };
};
